// extracted by mini-css-extract-plugin
export default {"wrap":"Media_wrap__k2jhq"};